import { motion } from 'framer-motion';
// material
import { styled } from '@mui/material/styles';
import { Typography, Stack, Container, Grid, Box } from '@mui/material';
import { varFadeInUp, varWrapEnter, varFadeInRight } from '../../animate';
import { SxProps } from '@mui/system';

// ----------------------------------------------------------------------

const RootStyle = styled(motion.div)(({ theme }) => ({
  position: 'relative',
  width: '100%',
  marginTop: '2em',
  [theme.breakpoints.down('md')]: {
    height: '80vh'
  }
}));

const ContentStyle = styled(motion.div)(({ theme }) => ({
  zIndex: 10,
  display: 'block',
  width: '100%',
  height: '80vh',
  position: 'absolute',
  top: '15%',
  bottom: 0,
  left: 0,
  right: 0,
  [theme.breakpoints.down('md')]: {
    height: '80vh'
  },
  [theme.breakpoints.up('lg')]: {
    top: '20%'
  }
}));

const HeroImgStyle = styled(motion.img)(({ theme }) => ({
  zIndex: 8,
  display: 'block',
  width: '100%',
  height: 'auto',
  [theme.breakpoints.down('md')]: {
    height: '80vh',
    objectFit: 'cover',
    objectPosition: '68%'
  }
}));

const HiddeOnLarge = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'none'
  }
}));
const HiddeOnSmall = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    display: 'none'
  }
}));
// ----------------------------------------------------------------------

export interface LandingTextHoverImageProps {
  text?: string;
  minimalText?: string;
  image: string;
  sx?: SxProps;
}

export default function LandingTextHoverImage({
  text,
  minimalText,
  image,
  sx
}: LandingTextHoverImageProps) {
  return (
    <>
      <RootStyle sx={sx} initial="initial" animate="animate" variants={varWrapEnter}>
        <HeroImgStyle alt="hero" src={image} variants={varFadeInUp} />
        <ContentStyle variants={varFadeInUp}>
          <Container maxWidth={'lg'}>
            <Grid container>
              <Grid item lg={8}>
                <HiddeOnLarge>
                  <Stack spacing={5}>
                    {text && (
                      <motion.div variants={varFadeInRight}>
                        <Typography align={'center'} variant={'h5'} sx={{ color: 'common.white' }}>
                          {text}
                        </Typography>
                      </motion.div>
                    )}
                    {minimalText && (
                      <motion.div variants={varFadeInRight}>
                        <Typography
                          align={'center'}
                          sx={{ color: 'common.white' }}
                          variant={'subtitle1'}
                        >
                          {minimalText}
                        </Typography>
                      </motion.div>
                    )}
                    <Box sx={{ margin: '2em' }} />
                  </Stack>
                </HiddeOnLarge>
                <HiddeOnSmall>
                  <Stack spacing={5}>
                    {text && (
                      <motion.div variants={varFadeInRight}>
                        <Typography variant={'h3'} sx={{ color: 'common.white' }}>
                          {text}
                        </Typography>
                      </motion.div>
                    )}
                    {minimalText && (
                      <motion.div variants={varFadeInRight}>
                        <Typography sx={{ color: 'common.white' }} variant={'h5'}>
                          {minimalText}
                        </Typography>
                      </motion.div>
                    )}
                    <Box sx={{ margin: '2em' }} />
                  </Stack>
                </HiddeOnSmall>
              </Grid>
            </Grid>
          </Container>
        </ContentStyle>
      </RootStyle>
    </>
  );
}
